import { render, staticRenderFns } from "./MandatoryColorModuleFilters.vue?vue&type=template&id=46fa9fc8&scoped=true"
import script from "./MandatoryColorModuleFilters.vue?vue&type=script&setup=true&lang=ts"
export * from "./MandatoryColorModuleFilters.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MandatoryColorModuleFilters.vue?vue&type=style&index=0&id=46fa9fc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fa9fc8",
  null
  
)

export default component.exports